import React from "react";
import { style, classes } from "typestyle";
import { RequestGcpSuggestionStatus } from "./types";
import { Button, ButtonStyleTypes, White } from "@traceair/tds";
import Done from "../../icons/Done";
import Warning from "../../icons/Warning";
import config from "../../../config";

const doneIconColor = "#01CB55";

const emailTo = config.fallbackGcpRequestEmail;
const urlToAskHelp = "mailto:" + emailTo;

interface IRequestGcpSuggestionPopupProps {
  onRequest: () => void;
  onHide: () => void;
  status: RequestGcpSuggestionStatus;
}

const RequestGcpSuggestionPopup = ({
  onRequest,
  onHide,
  status,
}: IRequestGcpSuggestionPopupProps) => (
  <div className={classes(wideStyle, gcpSuggestionPopupStyle)}>
    {status === "NOT_STARTED" && (
      <>
        <div className={lineStyle}>
          <span className={textStyle}>
            Request TraceAir to suggest the GCP network?
          </span>
          <div className={btnWrapperStyle}>
            <Button
              styleType={ButtonStyleTypes.ActiveB}
              title="No"
              className={classes(btnActiveCStyle, btnStyle)}
              onClick={() => onHide()}
            />
            <Button
              styleType={ButtonStyleTypes.ActiveA}
              title="Yes"
              className={btnStyle}
              onClick={() => onRequest()}
            />
          </div>
        </div>
      </>
    )}
    {status === "DONE" && (
      <div className={lineStyle}>
        <Done className={iconStyle} color={doneIconColor} />
        <span className={textStyle}>
          Request sent. TraceAir team will get back to you.
        </span>
      </div>
    )}
    {status === "FAILED" && (
      <div className={lineStyle}>
        <Warning className={iconStyle} />
        <span className={textStyle}>
          {`Failed to send request.\nPlease contact the TraceAir team directly`}
        </span>
        <div className={btnWrapperStyle}>
          <Button
            styleType={ButtonStyleTypes.ActiveB}
            title="Close"
            className={classes(btnActiveCStyle, btnStyle)}
            onClick={() => onHide()}
          />
          <Button
            styleType={ButtonStyleTypes.ActiveA}
            title="Contact"
            className={btnStyle}
            onClick={() => window.open(urlToAskHelp)}
          />
        </div>
      </div>
    )}
  </div>
);

export default RequestGcpSuggestionPopup;

const wideStyle = style({
  width: "100%",
});

const gcpSuggestionPopupStyle = style({
  width: "fit-content",
  maxWidth: 510,
  minWidth: 382,
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  cursor: "pointer",
  background: "rgba(0, 0, 0, 0.65)",
  borderRadius: 16,
  padding: "10px 24px",
});

const lineStyle = style({
  display: "flex",
  alignItems: "center",
  height: 36,
  $nest: {
    "& > svg": {
      marginRight: 10,
    },
  },
});

const textStyle = style({
  color: White,
  fontSize: 14,
  letterSpacing: -0.15,
  whiteSpace: "pre-wrap",
});

const iconStyle = style({
  display: "flex",
  flexShrink: 0,
});

const btnActiveCStyle = style({
  background: `${White} !important`,
});

const btnStyle = style({
  marginLeft: 8,
  minWidth: "60px !important",
});

const btnWrapperStyle = style({
  display: "flex",
  marginLeft: 21,
  $nest: {
    "& button:first-child": {
      margin: 0,
    },
  },
});
